(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ironside-hero-carousel-cyber"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Cuenta regresiva del hero Cyber: un solo intervalo para todos los contadores de la página.
    if (window.ihcCountdown) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    window.ihcCountdown = function () {
      document.querySelectorAll('[data-ihc-cd]').forEach(function (el) {
        var end = Date.parse(el.dataset.ihcCd);
        if (isNaN(end)) return;
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (s === 0) {
          if (!el.dataset.done && !el.querySelector('.ihc-cd__logo, .ihc-cd__cta')) { el.hidden = true; return; }
          el.querySelector('.ihc-cd__done').textContent = el.dataset.done;
          el.classList.add('is-done');
        } else {
          el.classList.remove('is-done');
          el.querySelector('[data-u="d"]').textContent = pad(Math.floor(s / 86400));
          el.querySelector('[data-u="h"]').textContent = pad(Math.floor((s % 86400) / 3600));
          el.querySelector('[data-u="m"]').textContent = pad(Math.floor((s % 3600) / 60));
          el.querySelector('[data-u="s"]').textContent = pad(s % 60);
        }
        el.hidden = false;
        el.classList.add('is-ready');
      });
    };
    // el JS de secciones se carga en todas las páginas: el intervalo solo corre si hay contadores
    var timer;
    var start = function () {
      if (timer || !document.querySelector('[data-ihc-cd]')) return;
      window.ihcCountdown();
      timer = setInterval(window.ihcCountdown, 1000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    document.addEventListener('shopify:section:load', function () { window.ihcCountdown(); start(); });
  })();

  (function () {
    if (customElements.get('ironside-hero-carousel')) return;

    function sendPromo(eventName, el, location) {
      var promo = {
        promotion_id: el.dataset.promotionId,
        promotion_name: el.dataset.promotionName,
        creative_name: el.dataset.creativeName,
        creative_slot: el.dataset.creativeSlot,
        location_id: location
      };
      var payload = { promotion_id: promo.promotion_id, promotion_name: promo.promotion_name,
        creative_name: promo.creative_name, creative_slot: promo.creative_slot, location_id: location,
        items: [{ item_id: promo.promotion_id, item_name: promo.promotion_name, promotion_id: promo.promotion_id,
          promotion_name: promo.promotion_name, creative_name: promo.creative_name, creative_slot: promo.creative_slot, location_id: location }] };
      try { if (typeof window.gtag === 'function') window.gtag('event', eventName, payload); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: eventName, ecommerce: payload }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + eventName, payload); } catch (e) {}
    }

    class IronsideHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track-el]');
        this.slides = Array.from(this.querySelectorAll('.ihc__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.interval = parseInt(this.dataset.interval, 10) || 6000;
        this.style.setProperty('--ihc-interval', this.interval + 'ms');
        this.location = this.dataset.location;
        this.seen = new Set();
        this.userPaused = false;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.canAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !reduce && !window.Shopify?.designMode;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(+d.dataset.dot, true)));
        this.track.addEventListener('pointerup', () => this.play(), { passive: true });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
        });

        var st;
        this.track.addEventListener('scroll', () => {
          clearTimeout(st);
          st = setTimeout(() => { this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth)); }, 80);
        }, { passive: true });

        if (this.dataset.track === 'true') {
          this.addEventListener('click', (e) => {
            var a = e.target.closest('[data-promo-click]');
            if (a) sendPromo('select_promotion', a.closest('.ihc__slide'), this.location);
          });
        }

        this.visObs = new IntersectionObserver(([en]) => {
          this.inView = en.isIntersecting;
          if (this.inView) this.trackView();
          this.inView && !this.userPaused ? this.play() : this.stop();
        }, { threshold: 0.5 });
        this.visObs.observe(this);
        document.addEventListener('visibilitychange', () => { document.hidden ? this.stop() : (!this.userPaused && this.play()); });
        this.setActive(0);
      }
      disconnectedCallback() { this.stop(); this.io?.disconnect(); this.visObs?.disconnect(); }
      go(i, manual) {
        var n = this.slides.length;
        i = ((i % n) + n) % n;
        this.track.scrollTo({ left: i * this.track.clientWidth });
        this.setActive(i);
        if (manual && !this.userPaused) this.play();
      }
      trackView() {
        var el = this.slides[this.index];
        if (this.dataset.track !== 'true' || !this.inView || !el || this.seen.has(el)) return;
        this.seen.add(el);
        sendPromo('view_promotion', el, this.location);
      }
      setActive(i) {
        this.index = i;
        this.trackView();
        this.slides.forEach((s, k) => { s.toggleAttribute('inert', k !== i); s.setAttribute('aria-hidden', k !== i); });
        this.dots.forEach((d, k) => d.setAttribute('aria-selected', k === i));
        // reinicia la animación de progreso
        if (this.hasAttribute('data-playing')) { this.removeAttribute('data-playing'); void this.offsetWidth; this.setAttribute('data-playing', ''); }
      }
      play() {
        if (!this.canAutoplay) return;
        this.stop();
        this.setAttribute('data-playing', '');
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }
      stop() { clearInterval(this.timer); this.removeAttribute('data-playing'); }
    }
    customElements.define('ironside-hero-carousel', IronsideHeroCarousel);

    document.addEventListener('shopify:block:select', (e) => {
      var c = e.target.closest?.('ironside-hero-carousel');
      if (c) c.go(+e.target.dataset.index);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
